import React from 'react';

const FunnelCardSkeleton: React.FC = () => {
  return (
    <div className="bg-white rounded-[20px] shadow-sm border border-gray-200 overflow-hidden animate-pulse">
      <div className="p-6">
        <div className="flex items-start gap-3 border-b border-gray-100 pb-4">
          {/* Image skeleton */}
          <div className="w-12 h-12 bg-gray-200 rounded-lg relative overflow-hidden">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_1s_infinite] bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200" />
          </div>
          
          <div className="flex-1">
            <div className="flex items-start justify-between">
              <div className="flex flex-col">
                {/* Status badge skeleton */}
                <div className="w-16 h-5 bg-gray-200 rounded-full mb-2 relative overflow-hidden">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_1s_infinite] bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200" />
                </div>
                {/* Title skeleton */}
                <div className="w-48 h-5 bg-gray-200 rounded relative overflow-hidden">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_1s_infinite] bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200" />
                </div>
              </div>
              {/* Menu button skeleton */}
              <div className="w-8 h-8 bg-gray-200 rounded-full relative overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_1s_infinite] bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200" />
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-4">
          {/* Date skeleton */}
          <div className="w-36 h-4 bg-gray-200 rounded mb-2 relative overflow-hidden">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_1s_infinite] bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200" />
          </div>
          {/* Description skeleton */}
          <div className="w-full h-7 bg-gray-200 rounded relative overflow-hidden">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_1s_infinite] bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200" />
          </div>
        </div>
      </div>
      
      {/* Action buttons skeleton */}
      <div className="px-6 py-3 overflow-x-hidden">
        <div className="flex space-x-3">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="w-12 h-12 bg-gray-200 rounded-full relative overflow-hidden">
              <div className="absolute inset-0 -translate-x-full animate-[shimmer_1s_infinite] bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200" />
            </div>
          ))}
        </div>
      </div>
      
      {/* Toggle section skeleton 
       <div className="px-6 py-3 border-t border-gray-100">
        <div className="flex items-center justify-between">
          <div className="w-40 h-5 bg-gray-200 rounded relative overflow-hidden">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_1s_infinite] bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200" />
          </div>
          <div className="w-11 h-6 bg-gray-200 rounded-full relative overflow-hidden">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_1s_infinite] bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200" />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default FunnelCardSkeleton;